import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {getCatalogue, getResourceFile} from '../../network';
import {formatPrice} from '../../helpers/Helper.js';
import {differenceBetweenTime, padding} from '../../utils/formatter';
import {productImagePreview} from '../../utils/helpers';

const SaleContainer = styled.div`
    margin-top: 10rem;
    width: inherit;
    
    .bg {
        position: absolute;   
    } 
    .text-container{
        display: flex;
        flex-direction: row;
        width: inherit;
        justify-content: space-between;
    }
    @media only screen and (max-width: 1100px) {
        /* padding-left: 3rem; */
    }
    @media only screen and (max-width: 800px) {
        .text-container{
            justify-content: space-evenly;
        }
    }
    @media only screen and (max-width: 500px) {
        .text-container{
       
        }
    }
`;
const CardWrapper = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-gap: 8rem;
    .sale-products{
        margin-top: 1rem;
        width: 35rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        
        > a {
          align-self: flex-end;
          margin-right: var(--space-32);
        }
    }
    @media only screen and (max-width: 1100px) {
        grid-gap: 0rem;
    }
    @media only screen and (max-width: 500px) {
        grid-auto-flow:row;
        justify-content:center;
        .sale-products{
            align-items: center;
        }
        
    }
    @media only screen and (max-width: 768px) {
        grid-auto-flow:row;
        justify-content:center;
        .sale-products{
            align-items: center;
        }
    }
`;

const SaleProductCard = styled.div`
    display: grid;
    grid-auto-flow: row;
    position: relative;
    width: 27.75rem;
    
    
    padding: var(--space-24) var(--space-24) var(--space-32) var(--space-24);
    
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.02), 0px 20px 25px rgba(0, 0, 0, 0.04);
    border-radius: var(--space-24);
    
    .badge {
        display: flex;
        padding: var(--space-4) var(--space-8);
        justify-content: center;
        align-items: center;
        
        width: fit-content;
        height: fit-content;
        
        margin-bottom: var(--space-32);
        
        color: var(--color-white);
        background: var(--color-orange-500);
        box-shadow: 0px 4px 6px rgba(221, 107, 32, 0.18), 0px 2px 4px rgba(221, 107, 32, 0.12);
        border-radius: var(--space-20);
        
        > span {
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-18);
            line-height: var(--font-18);
        }
    }
    
    .img-container {
        width: 100%;
        height: 11rem;
        
        justify-content: center;
        align-items: center;
        
        margin-bottom: var(--space-32);
        
        > img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    
    .item-name {
        margin-bottom: var(--space-48);
    
        font-family: sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-24);
        line-height: var(--font-32);
        
        color: var(--color-neutral-gray-900);
    }
    
    .price-layout {
        display: flex;
        flex-direction: row;
        
        align-items: center;
        //justify-content: space-between;
        
        margin-bottom: var(--space-40);
        
        .sale-price {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-36);
            line-height: var(--font-36);
            
            color: var(--company-dark);
        }
        
        .original-price {
            margin-left: var(--space-16);
            
            font-style: normal;
            font-weight: 500;
            font-size: var(--space-24);
            line-height: var(--space-18);
    
            text-decoration-line: line-through;
    
            color: var(--color-neutral-gray-500);
            
        }
    }
    
    .ticker-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        
        height: 5.5rem;
        
        margin-bottom: var(--space-48);
        
        background: var(--color-gray-100);
        
        border: 1px solid var(--color-gray-300);
        border-radius: var(--space-16);
        
        .ticker-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            
            .time-container {
                display: flex;
                flex-direction: column;
            
                h1 {
                    font-style: normal;
                    font-weight: 500;
                    font-size: var(--font-24);
                    line-height: var(--font-32);
                  
                    margin-bottom: var(--space-4);
            
                    text-align: center;
            
                    color: black;
                }
                
                span {
                    font-style: normal;
                    font-weight: bold;
                    font-size: var(--font-12);
                    line-height: var(--font-12);
            
                    text-align: center;
            
                    color: var(--company);
                }
            }
            
            .divider {
                margin-left: var(--space-24);
                margin-right: var(--space-24);
            
                width: 1px;
                height: var(--space-48);
                background: var(--color-gray-400);
            }
        }
    }
    
    button.sale-button {
        display: flex;
        align-items: center;
        justify-content: center;
        
        width: 100%;
        height: var(--space-56);
        
        padding: var(--space-16);
        color: white;
        
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-24);
        line-height: var(--font-24);
    
        background: var(--color-orange-500);
        box-shadow: 0px 4px 6px rgba(156, 66, 33, 0.12), 0px 2px 4px rgba(237, 137, 54, 0.32);
        border-radius: var(--space-8);
    }
    margin: 0 auto;
    @media (max-width: 500px){
        width: 24.75rem;
        transform: scale(0.9);

    }
    
`;

const SaleHeading = styled.h1`
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-40);
    line-height: 5rem;
    text-indent: 3rem;
    color: var(--color-gray-700);
    white-space: nowrap;
    
    @media (max-width: 500px){
        font-size: var(--font-32);
        text-indent: 0rem;
        line-height: 3rem;
    }
    @media (max-width: 400px){

    }
`;
const SmallHeading = styled.h1`
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1rem;
    color: var(--company-dark);
    position: relative;
    padding-top: 0.5rem;
    align-self: center;
 
`;
const SaleCardLayout = styled.div`
    margin-top: 4rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;

    @media only screen and (max-width: 500px) {
        margin-top: 0rem;
        flex-direction: column;
    }
`;
const CardContainer = styled.div`
 
  display: flex;
  flex-direction: column;
  
  width: 17rem;
  
  padding: 1rem;
  
  background: white;
  
  box-sizing: border-box;
  /* shadow-base */
  z-index:1;
 
  
  cursor: pointer;
`;

const ImageContainer = styled.div`
  display: flex;
  width: auto;
  height: 13.75rem;
  
  background: white;
  
  > img {
    position:relative;
    width: 90%;
    height: 90%;
    object-fit: contain;
    z-index:0;
    right: 5rem;
    padding: 1rem;
  }
  
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 3.5rem;
    height: 1.25rem;
    z-index:1;
    
    
    font-size: 0.75rem;
    line-height: 0.75rem;
    font-weight: bold;
    color: white;
    
    padding: 0.25rem 0.5rem;
    background: var(--color-orange-500);
    box-shadow: 0 var(--space-4) var(--space-6) rgba(221, 107, 32, 0.18), 0 var(--space-2) var(--space-4) rgba(221, 107, 32, 0.12);
    border-radius: 2.5rem;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  
  > span {
    font-size: 0.875rem;
    line-height: 1.25rem;
    
    color: #757575;
  }
`;

const Price = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  > .current {
    color: #232323;
    font-size: var(--font-20);
    line-height: var(--font-20);
    font-weight: 500;
    
    margin-right: var(--space-8);
  }
  
  > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 500;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: normal;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
    
    margin-top: 1rem;
`;

const Brand = styled.span`
    font-style: normal;
    font-weight: 600;
    line-height: 1.375rem;
    font-size: var(--font-16);
    color: #232323;
`;

function SaleCard({variant}) {
    return (
        <>
            {variant ?
                <CardContainer>
                    <ImageContainer>
                        <span>Sale</span>
                        {productImagePreview(variant.product) && <img src={productImagePreview(variant.product)} alt={variant.product.name}/>}
                    </ImageContainer>
                    <Title>
                        <Brand>{variant.product.brand.name}</Brand>{` ${variant.product.name}`}{`${variant.description ? `, ${variant.description}` : ''}`.trim()}
                    </Title>
                    <PriceContainer>
                        <Price>
                            <span className="current">{formatPrice((variant.price) - (variant.price / 100) * variant.discount)}</span><span
                            className="strikethrough"><s>{formatPrice(variant.price)}</s></span>
                        </Price>

                        {variant.product.prescription_required && <span>Prescription Required</span>}
                    </PriceContainer>
                </CardContainer>
                :
                null
            }
        </>
    );
}

function OnSale() {
    const [variants, setVariants] = useState([]);

    const [discountPeriod, setDiscountPeriod] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        getProducts();
    }, []);

    useEffect(() => {
        if (variants.length) {
            setInterval(() => {
                setDiscountPeriod(differenceBetweenTime(variants[0].discount_expiration, 'object'));
            }, 1000);
        }
    }, [variants]);

    const getProducts = () => {
        getCatalogue('', '', '', '', 100)
            .then(result => {
                const variants = result.data.map(product => {
                    let _product = {...product};
                    delete _product.variants;

                    return product.variants.map(variant =>
                        ({
                            ...variant,
                            product: _product
                        }));
                });
                const flattedVariants = variants.flat();
                const discountedVariants = flattedVariants.filter(variant => variant.discount > 0 && variant.discount_expiration > 0);

                setVariants([...discountedVariants]);
            })
            .catch(error => console.error(error));
    };

    const featuredVariant = variants.length ? variants[0] : null;

    return <>
        {
            variants.length !== 0 && <SaleContainer>
                 <div className="text-container">
                            <SaleHeading>Products On-Sale</SaleHeading>
                            <Link to={'/products'} style={{alignSelf:"center"}}><SmallHeading>View All</SmallHeading></Link>
                        </div>
                <CardWrapper>
                    <div>
                       
                        <SaleProductCard>
                            <p className="badge"><span>Sale</span></p>
                            <div className="img-container">
                                {productImagePreview(featuredVariant.product) && <img className="sale-image" src={productImagePreview(featuredVariant.product)}/>}
                            </div>
                            <p className="item-name">{featuredVariant.product.name}{featuredVariant.description ? ` - ${featuredVariant.description}` : ''}</p>
                            <div className="price-layout">
                                <span className="sale-price">{formatPrice(featuredVariant.price - ((featuredVariant.price / 100) * featuredVariant.discount), false)}</span>
                                <span className="original-price">{formatPrice(featuredVariant.price, false)}</span>
                            </div>
                            <div className="ticker-wrapper">
                                <div className="ticker-container">
                                    <div className="time-container">
                                        <h1>{padding(discountPeriod.days, 2)}</h1>
                                        <span>DAY</span>
                                    </div>
                                    <div className="divider"/>
                                    <div className="time-container">
                                        <h1>{padding(discountPeriod.hours, 2)}</h1>
                                        <span>HOURS</span>
                                    </div>
                                    <div className="divider"/>
                                    <div className="time-container">
                                        <h1>{padding(discountPeriod.minutes, 2)}</h1>
                                        <span>MINS</span>
                                    </div>
                                    <div className="divider"/>
                                    <div className="time-container">
                                        <h1>{padding(discountPeriod.seconds, 2)}</h1>
                                        <span>SECS</span>
                                    </div>
                                </div>
                            </div>
                            <button className="sale-button">View Item</button>
                        </SaleProductCard>
                    </div>

                    <div className="sale-products">
                        {
                            variants.length > 1 && <SaleCardLayout>
                                {
                                    variants.slice(1)
                                        .map((variant, index) => <SaleCard key={`SaleCard_${index}`} variant={variant}/>)
                                }
                            </SaleCardLayout>
                        }
                    </div>
                </CardWrapper>
            </SaleContainer>
        }
    </>;
}

export default OnSale;
